import React from 'react'
import EditPost from '../Uma_Sahni/Admin/EditPost'
import NewPost from '../Uma_Sahni/Admin/NewPost'
import PageDesign from '../Uma_Sahni/Admin/PageDesign'
import HomePageAdmin from '../Uma_Sahni/Admin/HomePageAdmin'




const Admin = () => {
 
  return (
    <div>
       <PageDesign> 
      <HomePageAdmin/>
       </PageDesign>
    </div>
  )
}

export default Admin